export const radii = {
  'pt-none': '0px',
  'pt-xs': '4px',
  'pt-sm': '8px',
  'pt-md': '16px',
  'pt-lg': '32px',
};
